import { render, staticRenderFns } from "./button-next-end.vue?vue&type=template&id=63b01c1b&scoped=true&lang=pug&"
import script from "./button-next-end.vue?vue&type=script&lang=js&"
export * from "./button-next-end.vue?vue&type=script&lang=js&"
import style0 from "./button-next-end.vue?vue&type=style&index=0&id=63b01c1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b01c1b",
  null
  
)

export default component.exports